import { UserManager, type UserManagerSettings } from "oidc-client-ts";
import { cleanOidcUrl } from "../utils/cleanOidcUrl";

const OIDC_CLIENT = "kairos-citizen-front";

export function initOidcManager(oidcUrl: string, metadataSeed?: UserManagerSettings["metadataSeed"]) {
  const oidcManager = new UserManager({
    client_id: OIDC_CLIENT,
    authority: oidcUrl,
    redirect_uri: cleanOidcUrl(window.location.href).toString(),
    loadUserInfo: true,
    metadataSeed,
  });
  oidcManager.events.addAccessTokenExpired((error: unknown) => {
    console.debug("Access token expired error", error);
  });
  oidcManager.events.addUserSignedOut(() => {
    alert("User signed out");
  });
  oidcManager.events.addSilentRenewError((error: unknown) => {
    console.debug("Silent renew error", error);
    // reload window to force user to sign in again
    window.location.reload();
  });
  return oidcManager;
}
